"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SoundService = void 0;
var _types = require("./types");
var _howler = require("howler");
var _Core = _interopRequireDefault(require("../Core"));
var _errorReporter = require("../../../utils/errorReporter");
var _logger = _interopRequireDefault(require("../../../utils/logger"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Only place with external DEPENDENCY!!!
 */
var SoundService = exports.SoundService = /*#__PURE__*/function () {
  function SoundService() {
    _classCallCheck(this, SoundService);
    _defineProperty(this, "_spritesLoaded", [false, false, false, false, false, false, false, false, false, false, false, false]);
    _defineProperty(this, "_howls", {});
    // Map to sounds currently or previous played.
    _defineProperty(this, "_soundSpriteIdMap", {});
    _defineProperty(this, "debugSounds", void 0);
    //Init howl
    _howler.Howler.mute(true);
    _howler.Howler.autoSuspend = false;
    window['ss'] = this;
    window['howler'] = _howler.Howler;
  }
  return _createClass(SoundService, [{
    key: "CreateSound",
    value: function CreateSound(sounds, files, volume, autoplay, loop) {
      // Howler handles loading by it self. we do not deems sound as critical. so sounds are not counted on load.
      var howl = new _howler.Howl({
        src: files,
        autoplay: autoplay,
        volume: volume,
        loop: loop
      });
      howl.originalVolume = volume;

      /// catch all errors from Howl.
      howl.on("playerror", function (e) {
        console.error(e);
        console.error(" playerror CreateSound");
      });
      for (var index = 0; index < sounds.length; index++) {
        this._howls[sounds[index]] = howl;
      }
    }
  }, {
    key: "CreateSoundFromSprite",
    value: function CreateSoundFromSprite(sound, sprite, files, volume, autoplay, loop) {
      var _this = this;
      try {
        // Howler handles loading by it self. we do not deems sound as critical. so sounds are not counted on load.
        var howl = new _howler.Howl({
          src: files,
          sprite: sprite,
          volume: volume
        });
        howl.once("load", function (e) {
          _this._spritesLoaded[sound] = true;
        });
        howl.on("playerror", function (e) {
          console.error(e);
          console.error(sound + " playerror");
        });
        howl.on("loaderror", function (e) {
          // we make this into warnings for now. Note this wont throw errors.
          // this is due to webkit automated testing in playwright throwing error on sound loads since it does not support sounds.
          console.warn(e);
          console.warn(sound + " loaderror");
        });
        if (_types.SoundPack.Game == sound) {
          howl.once("unlock", function () {
            _Core["default"].dispatch({
              type: _types.SOUND_UNLOCKED
            });
          });
        }
        howl.originalVolume = volume;
        this._howls[sound] = howl;
      } catch (e) {
        (0, _errorReporter.reportError)("Failed to create soundsprite, sound:" + sound + "  files" + files + "  ex: " + e);
        return;
      }
    }
  }, {
    key: "Play",
    value: function Play(sound, onlyOnce, spriteId, volume, stereo, force, delay) {
      var _this2 = this;
      if (!spriteId) {
        _logger["default"].error("played none sprited sound.");
        return;
      }
      if (!this._spritesLoaded[sound] && !force) return;
      if (this.debugSounds) _logger["default"].debug("PLAY Sound: " + sound + " onlyOnce: " + onlyOnce + " spriteId:" + spriteId);
      if (this._howls[sound]) {
        if (onlyOnce && this._soundSpriteIdMap[sound] && this._soundSpriteIdMap[sound][spriteId] && this._howls[sound].playing(this._soundSpriteIdMap[sound][spriteId])) {
          if (this.debugSounds) _logger["default"].debug(sound + " Sound already playing.");
          return;
        }
        setTimeout(function () {
          var id = _this2._howls[sound].play(spriteId);
          if (stereo != null) {
            _this2._howls[sound].stereo(stereo, id);
          }
          // note, if we do not pass id here, all sounds will go back to 1.
          _this2._howls[sound].volume(volume !== undefined ? volume : 1, id);
          // if this sound pack does not have any entry in the mapping.
          if (!_this2._soundSpriteIdMap[sound]) _this2._soundSpriteIdMap[sound] = {};
          _this2._soundSpriteIdMap[sound][spriteId] = id;
        }, delay);
      }
    }
  }, {
    key: "Fade",
    value: function Fade(sound, spriteId, from, to, duration) {
      if (!this._soundSpriteIdMap[sound]) {
        if (this.debugSounds) _logger["default"].debug("fading sound not started : " + spriteId);
        return;
      }
      var id = this._soundSpriteIdMap[sound][spriteId];

      //we do this since providing udefined in id will cause super random sounds to play.
      // howlerjs bug in imop
      if (id == null) {
        _logger["default"].warn("fade on nonexisting spriteId");
        return;
      }

      // from undefined, just fade it from current. ID here is very important
      if (from == null) {
        from = this._howls[sound].volume(null, id);
      }

      // just ignore if its a fade to fade
      if (from == to) return;
      if (this.debugSounds) _logger["default"].debug("FADE Sound: " + sound + " spriteId:" + spriteId + " from:" + from + " to:" + to + " duration:" + duration);
      this._howls[sound].fade(from, to, duration, id);
    }

    /**
     * Will increase sound to a level but not decrease it. So if sound is already at a higher level it will not be affected.
     * @param sound 
     * @param spriteId 
     * @param rate 
     * @returns 
     */
  }, {
    key: "Raise",
    value: function Raise(sound, spriteId, to, duration) {
      if (!this._soundSpriteIdMap[sound]) {
        if (this.debugSounds) _logger["default"].debug("Raiseing sound not started : " + spriteId);
        return;
      }
      var id = this._soundSpriteIdMap[sound][spriteId];

      // we do this since providing undefined in id will cause super random sounds to play.
      // howlerjs bug in imop
      if (id == null) {
        _logger["default"].warn("Raise on nonexisting spriteId");
        return;
      }
      var from = this._howls[sound].volume(null, id);

      // just ignore if its same or lower. we only raise 
      if (to <= from) return;
      if (this.debugSounds) _logger["default"].debug("Raise Sound: " + sound + " spriteId:" + spriteId + " from:" + from + " to:" + to + " duration:" + duration);
      this._howls[sound].fade(from, to, duration, id);
    }
  }, {
    key: "Rate",
    value: function Rate(sound, spriteId, rate) {
      if (!this._soundSpriteIdMap[sound]) {
        if (this.debugSounds) _logger["default"].debug("fading sound not started : " + spriteId);
        return;
      }
      var id = this._soundSpriteIdMap[sound][spriteId];

      //we do this since providing undefined in id will cause super random sounds to play.
      // howlerjs bug in imop
      if (id == null) {
        _logger["default"].warn("rate on nonexisting spriteId");
        return;
      }
      if (this.debugSounds) _logger["default"].debug("RATE Sound: " + sound + " spriteId:" + spriteId + " rate:" + rate);
      this._howls[sound].rate(rate);
    }
  }, {
    key: "Loop",
    value: function Loop(sound, spriteId, loop, actionOnEnd) {
      var _this3 = this;
      if (this.debugSounds) _logger["default"].debug("loop Sound: " + sound + " spriteId:" + spriteId);
      if (!this._soundSpriteIdMap[sound]) {
        if (this.debugSounds) _logger["default"].debug("fading sound no started : " + spriteId);
        return;
      }
      var id = this._soundSpriteIdMap[sound][spriteId];

      // from, just fade it from current.
      // console.log(!loop + " " + actionOnEnd)
      if (!loop) {
        //  console.log('setting end listener')
        this._howls[sound].once("end", function (a) {
          // important to stop the sound here, Since it might bug and play sounds still, like sounds that are in the sprite but etc.
          // had issues with that in knights fight FreeSpinEnd.
          _this3._howls[sound].stop(id);
          if (actionOnEnd) {
            //  console.log('send on end action')
            _Core["default"].dispatch(actionOnEnd);
          }
        }, id);
      }
      // console.warn("looping sound: " + sound + " spriteId:" + spriteId + " loop:" + loop + " actionOnEnd:" + actionOnEnd);
      // set looping to false for this sound.
      this._howls[sound].loop(loop, id);
    }
  }, {
    key: "StopSound",
    value: function StopSound(sound, fadeTime, spriteId) {
      var _this4 = this;
      if (this.debugSounds) _logger["default"].debug("Stopping Sound: " + sound + " Fade: " + fadeTime + " spriteId:" + spriteId);
      if (this._howls[sound]) {
        // Sound was never started.
        if (!this._soundSpriteIdMap[sound]) {
          return;
        }
        var id = this._soundSpriteIdMap[sound][spriteId];

        // we try top stop a sprite that didnot play it will stop ALL sounds on that pack.
        if (!id) {
          return;
        }
        if (!fadeTime) {
          this._howls[sound].stop(id);
        } else {
          this._howls[sound].once("fade", function () {
            _this4._howls[sound].stop(id);
          }, id);
          this._howls[sound].fade(this._howls[sound].volume(), 0, fadeTime, id);
        }
      }
    }
  }, {
    key: "MuteGroup",
    value: function MuteGroup(sound) {
      if (!this._howls[sound]) return;
      this._howls[sound].mute(true);
    }
  }, {
    key: "UnMuteGroup",
    value: function UnMuteGroup(sound) {
      if (!this._howls[sound]) return;
      this._howls[sound].mute(false);
    }
  }, {
    key: "Mute",
    value: function Mute() {
      // L.debug('mute!!! howler mute set')
      _howler.Howler.mute(true);
    }
  }, {
    key: "UnMute",
    value: function UnMute() {
      _howler.Howler.mute(false);
    }
  }]);
}();
//# sourceMappingURL=service.js.map